<template>
  <div class="main">
    <div
      class="dropzone-container"
      :style="isDragging && 'border-color: blue;'"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
    >
      <input
        id="fileInput"
        ref="file"
        :accept="accept"
        type="file"
        :multiple="multiple"
        name="file"
        class="hidden-input"
        @change="onChange"
      >
      <label for="fileInput" class="file-label">
        <div v-if="isDragging">{{ $t('release_to_drop_files_here') }}</div>
        <div v-else>{{ $t('drop_files_here_1') }} <u> {{ $t('drop_files_here_2') }} </u> {{ $t('drop_files_here_3') }} </div>
      </label>
      <!-- Note: Only add the code block below -->
      <div v-if="files.length" class="preview-container mt-4">
        <div v-for="file in files" :key="file.name" class="preview-cart">
          <v-row dense align="center" justify="center">
            <v-col cols="2">
              <v-icon v-if="file.type == 'application/pdf'" v-html="'$pdf'" />
              <img v-else class="preview-img" :src="generateURL(file)">
            </v-col>
            <v-col cols="6" class="d-inline-block text-truncate">
              {{ file.name }}
            </v-col>
            <v-col cols="2">
              {{ Math.round(file.size / 1000) + "kb" }}
            </v-col>
            <v-col cols="2">
              <button
                title="Remove file"
                class="ml-3"
                type="button"
                @click="remove(files.indexOf(file))"
              >
                <strong>×</strong>
              </button>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DropFile',
    props: {
      files: {
        type: Array,
        default: () => ([]),
      },
      accept: {
        type: String,
        default: '*.*',
      },
      multiple: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        isDragging: false,
        // files: [],
      }
    },
    methods: {
      onChange () {
        const self = this
        const incomingFiles = Array.from(this.$refs.file.files)

        const fileExist = self.files.some(existingFile =>
          incomingFiles.some(file => file.name === existingFile.name && file.size === existingFile.size),
        )

        if (fileExist) {
          self.showMessage = true
          alert('The new upload contains files that already exist.')
        } else {
          self.files.push(...incomingFiles)
        }
      },
      dragover (e) {
        e.preventDefault()
        this.isDragging = true
      },
      dragleave () {
        this.isDragging = false
      },
      drop (e) {
        e.preventDefault()
        this.$refs.file.files = e.dataTransfer.files
        this.onChange()
        this.isDragging = false
      },
      remove (i) {
        this.files.splice(i, 1)
      },
      generateURL (file) {
        if (file.type === 'application/pdf') {
          console.log(file)
        }
        const fileSrc = URL.createObjectURL(file)
        setTimeout(() => {
          URL.revokeObjectURL(fileSrc)
        }, 1000)
        return fileSrc
      },
    },
  }
</script>

<style scoped src="@/assets/dropfile.css"></style>
